import React from 'react';

export function LegacySpinner() {
  return (
    <img
      src='https://res.cloudinary.com/hevo/image/upload/v1661186315/dashboard/ajax-loader-big_v01ubx.gif'
      width='20px'
    />
  );
}
